import sigliveServiceV2 from 'Service/sigliveServiceV2';

const patchRoleAccess = async ({ id, payload }) => {
  const { data } = await sigliveServiceV2({ method: 'PATCH', url: `/access/role/${id}`, data: payload });

  return data;
};

export default patchRoleAccess;
